import BreakTask from 'components/hyperdrive/createTask/BreakTask';
import React from 'react';

export default function BreakTaskDrawer({ closeModal }) {
  return (
    <BreakTask closeModal={closeModal} />
  );
}
